import ImagePicker from "../imagePicker/ImagePicker";
import React, {useEffect, useState} from "react";
import {uploadImage} from "../../../api/uploadImage";
import {ToastSkin} from "../../../context/ToastContext";
import useUserContext from "../../../hooks/useUserContext";
import useToast from "../../../hooks/useToast";
import "./template-image-picker.css";

interface TemplateImagePickerProps {
    imageUrl?: string;
    setImageUrl: (newVal: string) => void;
    setIsLoading?: (newState: boolean) => void;
}

const TemplateImagePicker = ({ imageUrl, setImageUrl, setIsLoading }: TemplateImagePickerProps) => {
    const { selectedDomain } = useUserContext();
    const { showToast } = useToast();
    const [isUploadingImage, setIsUploadingImage] = useState(false);
    const [image, setImage] = useState<string | null>(null);

    const onImageConfirmed = async (newImage: string | null) => {
        setImage(newImage);
        if (newImage && selectedDomain) {
            setIsUploadingImage(true);
            const response = await uploadImage(selectedDomain, newImage);
            if (response.data.data) {
                setImageUrl(response.data.data);
                console.log("response.data.data: ", response.data.data);
                setIsUploadingImage(false);
            } else if (response.data.error) {
                showToast({skin: ToastSkin.error, text: response.data.error});
                setIsUploadingImage(false);
            }
        }
    }

    useEffect(() => {
        setIsLoading?.(isUploadingImage);
    }, [isUploadingImage]);

    return (
        <div className="template-image-uploader-container" id="image-uploader-container">
            <ImagePicker size={100} onImageConfirmed={onImageConfirmed} initialImageUrl={imageUrl || ''} previewUrl={imageUrl} isLoading={isUploadingImage} />
            <div className="details">
                <div className="title">Add image to your campaign</div>
                <div className="description">
                    Images boost engagement and help your campaign stand out.
                    Click here to upload or change the image.
                </div>
            </div>
        </div>
    )
}

export default TemplateImagePicker;